export const CALLTOACTION_COLORS = {
    none: 'bg-transparent border-transparent',
    white: 'bg-transparent border-grey-900/15 dark:border-grey-100/20',
    grey: 'bg-grey/10 border-transparent',
    blue: 'bg-blue/10 border-transparent',
    green: 'bg-green/10 border-transparent',
    yellow: 'bg-yellow/10 border-transparent',
    red: 'bg-red/10 border-transparent',
    pink: 'bg-pink/10 border-transparent',
    purple: 'bg-purple/10 border-transparent'
};